<notification type="error"
              *ngIf="errorNotification.isError">
    {{errorNotification.message}}
    <strong class="margin" [innerHTML]="errorNotification.val | price:currency"></strong>
</notification>
<btn *ngIf="isLatestOutputForAgency"
     (onClick)="reInitPrice()"
     [label]="wording.reInit"
     type="actionLink"></btn>
<div class="table" *ngIf="!reini">
    <div class="columnLeft">
        <table>
            <tr class="row">
                <th class="row1 title">{{wording.total}}</th>
                <th class="row1 rightAllign">
                    <strong *ngIf="!isTotalEditable || !isEdit; else inputTotal"
                            [innerHTML]="formValue.total | price:currency"></strong>
                    <ng-template #inputTotal>
                        <number class="input"
                                *ngIf="displayNumber.total"
                                id="total"
                                [fieldConfig]="config.totalConfig"
                                (onBlur)="editTotal()"
                                (onClick)="editTotal()"
                                (onEnter)="editTotal()"
                                (onUpDownClick)="editTotal()">
                        </number>
                    </ng-template>
                </th>
                <th class="row1 rightAllign diff">
                    <price-diff *ngIf="formValue"
                                [isOnlyDiff]="true"
                                [inverted]="true"
                                [values]="{base: formValue.total, difference: quote?.price?.retail?.total?.value, currency: currency, calculateDifference: true}"></price-diff>
                    <div class="tooltip">{{wording.originTotal}} : <span [innerHTML]="quote?.price?.retail?.total?.value | price:currency"></span></div>
                </th>
            </tr>
<!--            <tr class="row">-->
<!--                <td class="row1">{{wording.originTotal}}</td>-->
<!--                <td class="row1 rightAllign">-->
<!--                    <span [innerHTML]="quote.price.retail.total.value | price:currency"></span>-->
<!--                </td>-->
<!--            </tr>-->
            <tr class="row">
                <th class="row1 title">{{wording.margin}}</th>
                <th class="row1 rightAllign"><strong [innerHTML]="formValue.margin | price:currency"></strong></th>
                <th  class="row1 rightAllign diff">
                    <price-diff *ngIf="formValue"
                                [isOnlyDiff]="true"
                                [inverted]="true"
                                [values]="{base: formValue.margin, difference: formValue.commission, currency: currency, calculateDifference: true}"></price-diff>
                    <div class="tooltip">{{wording.commission}} : <span [innerHTML]="formValue.commission | price:currency"></span></div>
                </th>
            </tr>
<!--            <tr class="row">-->
<!--                <td class="row1">{{wording.commission}}</td>-->
<!--                <td class="rightAllign"><span [innerHTML]="formValue.commission | price:currency"></span></td>-->
<!--            </tr>-->
        </table>
    </div>
    <div class="columnRight" *ngIf="quote.price.retailAgency.traveller">
        <table>
            <tr class="row">
                <th [colSpan]="travellerName ? 2 : 1">{{wording.travellerTitle}}</th>
            </tr>
            <tr class="row" *ngFor="let id of travellerId" [id]="id">
                <td class="row1" *ngIf="travellerName">{{travellerName[id]}}</td>
                <td class="row1 rightAllign">
                    <strong *ngIf="isTotalEditable; else priceTraveller">{{wording.undefined}}</strong>
                    <ng-template #priceTraveller>
                        <strong *ngIf="!isEdit" [innerHTML]="formValue.travellers[id] | price:currency"></strong>
                        <number class="input"
                                *ngIf="isEdit && displayNumber[id]"
                                [fieldConfig]="config[id]"
                                (onBlur)="editPrice(id)"
                                (onEnter)="editPrice(id)"
                                (onClick)="editPrice(id)"
                                (onUpDownClick)="editPrice(id)">
                        </number>

                    </ng-template>
                </td>

            </tr>
        </table>

    </div>
</div>
